import { CircularProgress } from '@mui/material';
import axios from 'axios';
import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { useMobileApp } from '../../../../../hooks/useMobileApp';
import { UiComponentElementInterface, VideoComponentInterface } from '../../../../../interfaces/pagebuilder';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import { createDisplayLink } from '../../../../../services/helper';
import VyReactPlayer from '../../../../common/VyReactPlayer';
import EmptyComponent from '../../../pageBuilder/EmptyComponent';
import { TitleAndDescription } from '../../../pageBuilder/TitleAndDescription';
import VideoTemplate from '../VideoTemplate';

const WatermarkVideo = ({ renderTask, thumbnail, autoplay, muted }: { renderTask?: string; thumbnail?: string; autoplay?: boolean; muted?: boolean }) => {
  const userid = useSelector((state) => state.common.user?._id);
  const [videoUrl, setVideoUrl] = useState<string>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { t } = useTranslation(['pagebuilder']);
  const { isAppView } = useMobileApp();

  async function fetchVideo() {
    setIsLoading(true);
    if (!userid) return;
    try {
    } catch (err) {
      console.error(err);
    }
    setIsLoading(false);
  }

  useEffect(() => {
    if (renderTask && userid) fetchVideo();
  }, [userid]);

  if (!userid) return <></>;
  if (isLoading || !videoUrl) return <CircularProgress />;

  return (
    <ReactPlayer
      playsinline={isAppView()}
      light={thumbnail && !autoplay ? createDisplayLink(thumbnail, false) : undefined}
      width="100%"
      height="100%"
      controls
      playing={autoplay ?? false}
      muted={muted ?? false}
      url={videoUrl}
      config={{
        file: {
          attributes: {
            onContextMenu: (e: any) => e.preventDefault(),
          },
        },
      }}
    />
  );
};

const VideoUiComponent = ({ uiComponent }: UiComponentElementInterface<VideoComponentInterface>) => {
  const { t } = useTranslation('pagebuilder');
  return (
    <>
      <TitleAndDescription component={uiComponent!} />
      <div
        className={`w-full`}
        style={{
          color: uiComponent?.styling?.textColor || '#000',
        }}>
        {(uiComponent?.videoSettings?.videoFiles && uiComponent?.videoSettings?.videoFiles?.length > 0) || uiComponent?.videoSettings?.url ? (
          <div className="h-0 pt-[56.25%] w-full relative">
            <div className="absolute top-0 left-0 w-full h-full">
              {uiComponent?.videoSettings?.videotype === 'url' && (
                <VyReactPlayer
                  props={{
                    style: { backgroundColor: 'black', width: '100%', maxWidth: '100% !important' },
                    width: '100%',
                    height: '100%',
                    controls: true,
                    url: uiComponent.videoSettings.url,
                    playing: uiComponent?.videoSettings?.autoplay,
                    muted: uiComponent?.videoSettings?.muted,
                    light:
                      uiComponent?.videoSettings?.thumbnail && !uiComponent?.videoSettings?.autoplay
                        ? createDisplayLink(uiComponent?.videoSettings?.thumbnail, false)
                        : undefined,
                  }}
                />
              )}
              {uiComponent?.videoSettings?.videotype === 'upload' && <VideoTemplate videoSettings={uiComponent?.videoSettings} />}
            </div>
          </div>
        ) : (
          <EmptyComponent componentName={t('pagebuilder:video')} />
        )}
      </div>
    </>
  );
};

export default VideoUiComponent;
